/* Start the next collection row before it reaches the viewport.
 * Native lazy loading remains the fallback and may start downloads even earlier. */
(() => {
  if (window.albCollectionPreload || !('IntersectionObserver' in window)) return;
  window.albCollectionPreload = true;
  let observer;
  let resizeTimer;
  function start() {
    if (observer) observer.disconnect();
    document.querySelectorAll('[data-alb-row-promoted]').forEach(image => {
      image.sizes = Math.ceil(image.getBoundingClientRect().width) + 'px';
    });
    const images = [...document.querySelectorAll('#CollectionAjaxContent [data-alb-grid-primary][loading="lazy"]')];
    if (!images.length) return;
    const card = images[0].closest('.grid-product');
    const rowHeight = Math.ceil(card ? card.getBoundingClientRect().height : 320);
    observer = new IntersectionObserver(entries => {
      entries.forEach(({target: image, isIntersecting}) => {
        if (!isIntersecting) return;
        // Do not alter an already loaded image or trigger a new candidate.
        // Automatic sizes require lazy loading, so freeze the actual card width.
        if (!image.complete || !image.naturalWidth) {
          image.sizes = Math.ceil(image.getBoundingClientRect().width) + 'px';
          image.setAttribute('data-alb-row-promoted', '');
          image.loading = 'eager';
        }
        observer.unobserve(image);
      });
    }, {rootMargin: `0px 0px ${Math.max(320, rowHeight + 32)}px 0px`});
    images.forEach(image => observer.observe(image));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('collection:reloaded', start);
  document.addEventListener('shopify:section:load', start);
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(start, 150);
  }, {passive: true});
})();
